<template>
    <div class="mb-5">
        <h2 v-if="title" class="pb-5">{{title}}</h2>
        <p v-if="text" class="pb-5">{{text}}</p>
        <p v-if="text2" class="pb-5">{{text2}}</p>
        <ul v-if="ulContentHtml" class="pb-2">
            <li v-for="t of ulContentHtml.split('\n')" :key="t">{{t}}</li>
        </ul>
        <div v-if="contentHtml" class="pb-2">
            <div v-html="contentHtml"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String            
            },
            text: {
                type: String
            },
            text2: {
                type: String
            },
            ulContentHtml: { //ul as html code
                type: String
            },
            contentHtml: { //html code
                type: String
            }
        },
    }
</script>

<style lang="css" scoped>
ul {
   margin-left: 1.5em !important;
}
</style>